import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants';
import { getEmails } from '../services';
const useGetEmails = (email, recipient) => {
    return useQuery({
        queryKey: [QueryKeys.GetEmails, email],
        queryFn: async () => {
            const response = await getEmails(email, recipient ? 1 : 0);
            return response.data;
        },
        enabled: email.length >= 3,
    });
};
export default useGetEmails;
